import { Injectable } from '@angular/core';
import { PrettyNumberPipe } from '../../pipes/pretty-number.pipe';

@Injectable({
  providedIn: 'root',
})
export class PrettyNumberPipeHelperService {
  constructor(private _pipe: PrettyNumberPipe) {}

  transform(val: number | string, abbreviate = true, unit?: string): string {
    return this._pipe.transform(val as number, abbreviate, unit);
  }
}
